/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_OriginalInputs */

const en_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const es_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const fr_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const de_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const ja_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナル`)
};

const zh_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原作`)
};

const ar_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أصلي`)
};

const id_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asli`)
};

const it_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originale`)
};

const ru_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оригинал`)
};

const pt_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const ko_val_original = /** @type {(inputs: Val_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`원본`)
};

/**
* | output |
* | --- |
* | "Original" |
*
* @param {Val_OriginalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_original = /** @type {((inputs?: Val_OriginalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_OriginalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_original(inputs)
	if (locale === "es") return es_val_original(inputs)
	if (locale === "fr") return fr_val_original(inputs)
	if (locale === "de") return de_val_original(inputs)
	if (locale === "ja") return ja_val_original(inputs)
	if (locale === "zh") return zh_val_original(inputs)
	if (locale === "ar") return ar_val_original(inputs)
	if (locale === "id") return id_val_original(inputs)
	if (locale === "it") return it_val_original(inputs)
	if (locale === "ru") return ru_val_original(inputs)
	if (locale === "pt") return pt_val_original(inputs)
	return ko_val_original(inputs)
});